/* eslint-disable */
import ReportSalesAndProfitList from './report-sales-and-profit.list';

export default {
  list: ReportSalesAndProfitList,
};
